export const radii = {
  none: '0',
  sm: '6px',
  base: '8px',
  md: '8px',
  lg: '10px',
  xl: '16px',
  '2xl': '16px',
  '3xl': '16px',
  full: '9999px',
};

export const shadows = {
  xs: '0 1px 2px rgba(0, 0, 0, 0.05)',
  sm: '0 1px 2px rgba(0, 0, 0, 0.05)',
  base: '0 1px 2px rgba(0, 0, 0, 0.05)',
  md: '0 2px 4px rgba(41, 41, 41, 0.06)',
  lg: '0 8px 24px rgba(41, 41, 41, 0.08)',
  xl: '0 12px 32px rgba(41, 41, 41, 0.10)',
  outline: '0 0 0 3px rgba(201, 201, 201, 0.24)',
  control: '0 1px 2px rgba(0, 0, 0, 0.05)',
  frame: '0 0 0 1px rgba(41, 41, 41, 0.10)',
  card: '0 0 0 1px rgba(41, 41, 41, 0.01), 0 0 2px rgba(41, 41, 41, 0.10)',
  popover: '0 0 0 1px rgba(41, 41, 41, 0.06), 0 8px 24px rgba(41, 41, 41, 0.10)',
};

export const space = {
  control: '12px',
  field: '16px',
  card: '20px',
  section: '32px',
};

export const controlScale = {
  md: { h: '38px', px: '12px', buttonPx: '15px', radius: '10px', font: '13px', icon: 16 },
  sm: { h: '34px', px: '12px', buttonPx: '13px', radius: '10px', font: '13px', icon: 14 },
  xs: { h: '30px', px: '10px', buttonPx: '10px', radius: '8px', font: '12px', icon: 14 },
};

export const sizes = {
  control: controlScale.md.h,
  controlSm: controlScale.sm.h,
  controlXs: controlScale.xs.h,
  navItem: '32px',
  row: '45px',
};
